import React from 'react';
function createCommonjsModule(fn) {
  var module = {
    exports: {}
  };
  return fn(module, module.exports), module.exports;
}

/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

var classnames = createCommonjsModule(function (module) {
  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
      var classes = [];
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;
        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg) && arg.length) {
          var inner = classNames.apply(null, arg);
          if (inner) {
            classes.push(inner);
          }
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }
      return classes.join(' ');
    }
    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});
var wrapWithRequired = function wrapWithRequired(validator, isRequired) {
  if (isRequired) {
    return {
      isRequired: validator
    };
  }
  return validator;
};
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var _excluded = ["id", "className", "style", "classNames", "as", "size", "weight", "align", "uppercase", "children"];
var HeadingAsElement = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  p: "p",
  span: "span",
  div: "div"
};
var Heading = function Heading(_ref) {
  var _cx;
  var id = _ref.id,
    className = _ref.className,
    style = _ref.style,
    classNames = _ref.classNames,
    as = _ref.as,
    size = _ref.size,
    weight = _ref.weight,
    align = _ref.align,
    uppercase = _ref.uppercase,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var Tag = "" + as;
  var classes = classnames((_cx = {}, _cx[classNames == null ? void 0 : classNames["heading--" + size]] = size && (classNames == null ? void 0 : classNames["heading--" + size]), _cx[classNames == null ? void 0 : classNames["heading--" + weight]] = weight && (classNames == null ? void 0 : classNames["heading--" + weight]), _cx[classNames == null ? void 0 : classNames["heading--" + align]] = align && (classNames == null ? void 0 : classNames["heading--" + align]), _cx[classNames == null ? void 0 : classNames["heading--uppercase"]] = uppercase && (classNames == null ? void 0 : classNames["heading--uppercase"]), _cx[className] = className, _cx));
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: classes,
    id: id
  }, props, {
    style: style
  }), children);
};
Heading.displayName = "Heading";
Heading.defaultProps = {
  id: undefined,
  className: undefined,
  style: undefined,
  as: HeadingAsElement.h1,
  size: undefined,
  weight: undefined,
  align: "left",
  uppercase: false,
  children: undefined
};
var SectionAsElement = {
  section: "section",
  header: "header",
  footer: "footer"
};
var Section = function Section(_ref) {
  var _cx;
  var className = _ref.className,
    classNames = _ref.classNames,
    as = _ref.as,
    theme = _ref.theme,
    padding = _ref.padding,
    full = _ref.full,
    backgroundImage = _ref.backgroundImage,
    TitleComponent = _ref.TitleComponent,
    titleId = _ref.titleId,
    titleClassNames = _ref.titleClassNames,
    title = _ref.title,
    titleAs = _ref.titleAs,
    titleSize = _ref.titleSize,
    titleWeight = _ref.titleWeight,
    titleAlignment = _ref.titleAlignment,
    titleUppercase = _ref.titleUppercase,
    children = _ref.children;
  var Tag = "" + as;
  return /*#__PURE__*/React.createElement(Tag, {
    className: classnames(classNames == null ? void 0 : classNames.section, (_cx = {}, _cx[classNames == null ? void 0 : classNames["section--" + theme]] = theme && (classNames == null ? void 0 : classNames["section--" + theme]), _cx[classNames == null ? void 0 : classNames["section--padding-" + padding]] = padding && (classNames == null ? void 0 : classNames["section--padding-" + padding]), _cx[classNames == null ? void 0 : classNames["section--full"]] = full && (classNames == null ? void 0 : classNames["section--full"]), _cx[classNames == null ? void 0 : classNames["section--has-background-image"]] = backgroundImage && (classNames == null ? void 0 : classNames["section--has-background-image"]), _cx[className] = className, _cx)),
    "data-section-theme": theme
  }, backgroundImage && /*#__PURE__*/React.createElement("div", {
    className: classNames == null ? void 0 : classNames["section__background-image-container"]
  }, backgroundImage), /*#__PURE__*/React.createElement("div", {
    className: classNames == null ? void 0 : classNames.section__container
  }, !!title && /*#__PURE__*/React.createElement(TitleComponent, {
    id: titleId,
    className: classNames == null ? void 0 : classNames.section__title,
    classNames: titleClassNames,
    as: titleAs,
    size: titleSize,
    weight: titleWeight,
    align: titleAlignment,
    uppercase: titleUppercase
  }, title), /*#__PURE__*/React.createElement("div", {
    className: classNames == null ? void 0 : classNames.section__content
  }, children)));
};
Section.displayName = "Section";
Section.defaultProps = {
  className: undefined,
  as: SectionAsElement.section,
  theme: undefined,
  padding: undefined,
  full: false,
  backgroundImage: undefined,
  TitleComponent: Heading,
  titleId: undefined,
  titleClassNames: undefined,
  title: undefined,
  titleAs: HeadingAsElement.h2,
  titleSize: undefined,
  titleWeight: undefined,
  titleAlignment: "center",
  titleUppercase: false,
  children: undefined
};
export default Section;
export { Section, SectionAsElement };